/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import TextHeadline from '../../atoms/TextHeadline/TextHeadline';
import CustomEmblaCarouselHome24 from '../../organisms/CustomEmblaCarouselHome24';
import Styles from './Home24Parceiros.css';
import { isMobile } from '@/utils/browser';

function Home24Parceiros() {
  return (
    <section id="santander-parceiros">
      <ContainerHome24>
        <h2 className="santander-parceiros-title">Parceiros Santander</h2>
        <p className="santander-parceiros-text">Um ecossistema completo, com tudo que precisar.</p>

        <div className="santander-parceiros-carrossel">
          <CustomEmblaCarouselHome24
            loop
            enableBullets
            enableMobileArrows
            options={{ slidesToScroll: isMobile() ? 2 : 4 }}
            detectBulletCount
          >
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  <a
                    className="parceiros-card"
                    href="https://www.webmotors.com.br/?utm_source=santander-financiamentos&utm_medium=pagina-home-parceiros-webmotors"
                    target="_blank"
                    rel="noopener"
                    id="parceiro-webmotors"
                  >
                    <img src="assets/home24/parceiros/webmotors.png" alt="" />
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="parceiros-card"
                    href="https://fitenergia.com.br/santander?utm_source=indicacao&utm_medium=indicfinanceira&utm_campaign=financeiracanaldigitalsantander"
                    target="_blank"
                    rel="noopener"
                    id="parceiro-fit-energia"
                  >
                    <img src="assets/home24/parceiros/fit.png" alt="" />
                  </a>
                </div>
                {/* <div className={`slide ${className}`}>
                  <a
                    className="parceiros-card"
                    href="https://emprestimosim.com.br?utm_source=santander&utm_medium=santander_financiamentos&utm_campaign=card_parceiros"
                    target="_blank"
                    rel="noopener"
                    id="parceiro-sim"
                  >
                    <img src="assets/home24/parceiros/sim.png" alt="" />
                  </a>
                </div> */}
                <div className={`slide ${className}`}>
                  <a
                    className="parceiros-card"
                    href="https://portal.santanderauto.com.br/home?int_source=portalSF&int_medium=home:card:parceiros&int_campaign=santander-auto"
                    target="_blank"
                    rel="noopener"
                    id="parceiro-santander-auto"
                  >
                    <img src="assets/home24/parceiros/santander-auto.png" alt="" />
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a className="parceiros-card" href="car10.html" id="parceiro-car10">
                    <img src="assets/home24/parceiros/web-servicos.png" alt="" />
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="parceiros-card"
                    href="https://tagsantander.semparar.com.br/#/?utm_source=santander-financiamentos&utm_medium=pagina-home-parceiros-sem-parar"
                    target="_blank"
                    rel="noopener"
                    id="parceiro-semparar"
                  >
                    <img src="assets/home24/parceiros/sem-parar.png" alt="" />
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="parceiros-card"
                    href="https://loopcarros.com.br/?utm_source=santander-financiamentos&utm_medium=pagina-home-parceiros-loop"
                    target="_blank"
                    rel="noopener"
                    id="parceiro-loop"
                  >
                    <img src="assets/home24/parceiros/loop.png" alt="" />
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="parceiros-card"
                    href="https://solution4fleet.com.br/?utm_source=santander-financiamentos&utm_medium=pagina-home-parceiros-s4fleet"
                    target="_blank"
                    rel="noopener"
                    id="parceiro-s4f"
                  >
                    <img src="assets/home24/parceiros/s4f.png" alt="" />
                  </a>
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>
      </ContainerHome24>

      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24Parceiros;
